export default "__VITE_ASSET__ed8e58c0__"